module.exports = __webpack_public_path__ + "img/internet.6fc2f26b.webp";